// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='LayoutControls'] {\n  height: 20px;\n}\n  [name='LayoutControls'] [name='Button'] {\n    margin-left: 17px;\n    padding: 0;\n  }\n  [name='LayoutControls'] [name='Button'] img {\n      width: 18px;\n      height: 18px;\n    }\n", ""]);
// Exports
module.exports = exports;
